import { apiPost } from "@apps/dashboard/lib/api-fetch";
import { authClient } from "@apps/dashboard/lib/auth-client";
import type { Locale } from "@project/i18n";

type PasskeyPreAuthContextResponse = {
  context: string;
  expiresInSeconds: number;
};

export async function registerPasskeyWithPreAuthContext(locale: Locale): Promise<void> {
  const preauth = await apiPost<PasskeyPreAuthContextResponse>(
    "/auth/passkey/preauth-context",
    {},
    locale,
  );
  const result = await authClient.passkey.addPasskey({
    context: preauth.context,
    authenticatorAttachment: "platform",
  });
  if (result.error) {
    throw result.error;
  }
}
